/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_StaplesInputs */

const en_shopping_staples = /** @type {(inputs: Shopping_StaplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staples`)
};

const de_shopping_staples = /** @type {(inputs: Shopping_StaplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorrat`)
};

/**
* | output |
* | --- |
* | "Staples" |
*
* @param {Shopping_StaplesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_staples = /** @type {((inputs?: Shopping_StaplesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_StaplesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_staples(inputs)
	return en_shopping_staples(inputs)
});